import Link from '@/components/utilities/SmartLink';
import { useGlossaryLabels } from '@/utils/glossary-labels';
import { useAppContext } from '@/components/utilities/AppContext';

const GlossaryBreadcrumb = ({ glossaryRootPath, glossaryRootLabel, termTitle }) => {
  const labels = useGlossaryLabels();
  const { locale } = useAppContext();
  const homeHref = locale && locale !== 'cs' ? `/${locale}` : '/';

  return (
    <nav
      aria-label={labels.breadcrumbAriaLabel}
      className="text-grey-500 flex flex-wrap items-center gap-2 text-[13px]"
    >
      <Link href={homeHref} className="hover:text-grey-900 transition-colors">
        Leadhub.co
      </Link>
      <span className="text-grey-400">›</span>
      <Link href={glossaryRootPath} className="hover:text-grey-900 transition-colors">
        {glossaryRootLabel}
      </Link>
      <span className="text-grey-400">›</span>
      <span className="text-grey-900">{termTitle}</span>
    </nav>
  );
};

export default GlossaryBreadcrumb;
